import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Attachment, ApiResponse, DialogCloseResult } from '../attachment.interface';

@Component({
  selector: 'meu-modal-upload-file',
  templateUrl: './modal-upload-file.component.html',
  styleUrls: ['./modal-upload-file.component.scss']
})
export class ModalUploadFileComponent implements OnInit {
  isLoading = false;
  selectedFile: File | null = null;
  fileName: string = '';
  attachmentId: string;
  attachmentName: string;
  private apiUrl = environment.backendhost + '/api/attachments';

  constructor(
    public dialogRef: MatDialogRef<ModalUploadFileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: string; name: string },
    private toastr: ToastrService,
    private http: HttpClient
  ) {
    this.attachmentId = data.id;
    this.attachmentName = data.name;
  }

  ngOnInit() {}

  onFileSelected(event: Event) {
    const target = event.target as HTMLInputElement;
    const file = target.files && target.files[0];
    if (file) {
      this.selectedFile = file;
      this.fileName = file.name;
    }
  }

  removeFile() {
    this.selectedFile = null;
    this.fileName = '';
  }

  onSubmit() {
    if (!this.selectedFile) {
      this.toastr.warning('Vui lòng chọn file');
      return;
    }

    this.isLoading = true;
    const formData = new FormData();
    formData.append('file', this.selectedFile);

    this.http.put<ApiResponse<Attachment>>(`${this.apiUrl}/${this.attachmentId}/upload`, formData).subscribe(
      (res) => {
        this.isLoading = false;
        if (res.success) {
          this.toastr.success('Upload file thành công');
          this.dialogRef.close({ event: true } as DialogCloseResult);
        } else {
          this.toastr.error(res.message || 'Không thể upload file');
        }
      },
      (error) => {
        this.isLoading = false;
        this.toastr.error('Có lỗi xảy ra khi upload file');
        console.error('Error uploading file:', error);
      }
    );
  }

  onCancel() {
    this.dialogRef.close();
  }
}
